// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 950 ? "mediapipe-bg-worker" : chunkId) + "." + {"249":"18a4fb9b","950":"2411102a"}[chunkId] + ".chunk.js";
};